import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "button-content"
};
const _hoisted_2 = { class: "center-group" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "textCol" };
const _hoisted_5 = {
    key: 0,
    class: "rightIconCol"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = { key: 1 };
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGButton',
    props: {
        text: { default: '' },
        outline: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        arrow: { type: Boolean, default: false },
        alt: { type: Boolean, default: false },
        alt2: { type: Boolean, default: false },
        icon: { default: '' },
        open: { type: Boolean, default: false },
        circle: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        fullWidth: { type: Boolean, default: false },
        color: { default: '' },
        stacked: { type: Boolean, default: false },
        closerStack: { type: Boolean, default: false },
        textOnly: { type: Boolean, default: false },
        noCaps: { type: Boolean, default: false },
        plus: { type: Boolean, default: false },
        leftIconSize: { default: 30 },
        backgroundColor: { default: '' },
        leftAlign: { type: Boolean, default: false },
        transparent: { type: Boolean, default: false },
        inlineArrow: { type: Boolean, default: false }
    },
    emits: ["click"],
    setup(__props) {
        _useCssVars(_ctx => ({
            "ff37e200": ((_ctx.leftIconSize || 30) + 'px')
        }));
        const { isDarkMode } = useDarkMode();
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['mg-button-wrapper', { 'left-align': _ctx.leftAlign, 'inline-arrow': _ctx.inlineArrow }])
            }, [
                (!_ctx.circle)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        elevation: "0",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click'))),
                        class: _normalizeClass('mg-button ' +
                            (_ctx.small ? 'mgButtonSmall ' : ' ') +
                            (_ctx.alt ? 'alt ' : ' ') +
                            (_ctx.alt2 ? 'alt2 ' : ' ') +
                            (_ctx.outline ? 'outline ' : ' ') +
                            (_ctx.textOnly ? 'textOnly ' : ' ') +
                            (_ctx.fullWidth ? 'fullWidth ' : ' ') +
                            (_ctx.stacked ? 'mgButtonStacked ' : ' ') +
                            (_ctx.closerStack ? 'mgButtonCloserStack ' : ' ') +
                            (_ctx.noCaps ? 'mgButtonNoCaps ' : ' ') +
                            (_ctx.backgroundColor ? 'custom-bg ' : ' ') +
                            (_ctx.transparent ? 'transparent-bg ' : ' ') +
                            (_unref(isDarkMode) ? 'dark ' : ' ')),
                        disabled: _ctx.disabled,
                        variant: _ctx.textOnly ? 'text' : undefined,
                        style: _normalizeStyle(_ctx.backgroundColor ? { '--custom-bg-color': _ctx.backgroundColor } : {})
                    }, {
                        default: _withCtx(() => [
                            ((!_ctx.small || _ctx.leftAlign) && !_ctx.circle)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        (_ctx.icon && !_ctx.icon.startsWith('mdi-'))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "leftIcon",
                                                src: _ctx.icon
                                            }, null, 8, _hoisted_3))
                                            : _createCommentVNode("", true),
                                        (_ctx.icon && _ctx.icon.startsWith('mdi-'))
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                class: "leftIcon",
                                                icon: _ctx.icon
                                            }, null, 8, ["icon"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.text), 1)
                                    ]),
                                    (_ctx.arrow || _ctx.open || _ctx.plus)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            (_ctx.arrow)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    class: _normalizeClass(['arrow', 'rightIcon', !_ctx.alt && !_ctx.alt2 && !_ctx.outline && !_ctx.transparent ? 'white-arrow' : '']),
                                                    src: (_ctx.alt || _ctx.alt2 || _ctx.outline || _ctx.transparent ? require('@/assets/arrow-right.png') : require('@/assets/light-arrow-right.png'))
                                                }, null, 10, _hoisted_6))
                                                : _createCommentVNode("", true),
                                            (_ctx.open)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    class: "open rightIcon",
                                                    src: (_ctx.alt || _ctx.alt2 || _ctx.outline ? require('@/assets/chevron-down.png') : require('@/assets/chevron-down.png'))
                                                }, null, 8, _hoisted_7))
                                                : _createCommentVNode("", true),
                                            (_ctx.plus)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 2,
                                                    class: "plus rightIcon",
                                                    src: (_ctx.alt || _ctx.alt2 || _ctx.outline ? require('@/assets/plus-inverted.png') : require('@/assets/plus-inverted.png'))
                                                }, null, 8, _hoisted_8))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.small && !_ctx.leftAlign)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.text), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["class", "disabled", "variant", "style"]))
                    : _createCommentVNode("", true),
                (_ctx.circle)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('click'))),
                        color: _ctx.color ? _ctx.color : (_ctx.alt ? '#E0C5C8' : '#281C3B'),
                        icon: _ctx.icon,
                        density: _ctx.small ? 'compact' : 'default'
                    }, null, 8, ["color", "icon", "density"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
